const PUSH_CHANNEL_ID = 'pointage_alerts';

let initialized = false;
let registeredToken = '';

function isAndroidNative(Capacitor) {
  return Capacitor?.isNativePlatform?.() && Capacitor.getPlatform?.() === 'android';
}

async function postPushToken(path, token) {
  if (!token) return;
  await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, platform: 'android' }),
  });
}

function pushRoute(router, route) {
  const fallback = '/notifications';
  const target = route || fallback;
  try {
    if (!target.startsWith('http')) {
      const [pathPart, queryString = ''] = target.split('?');
      router.push({
        path: pathPart || fallback,
        query: Object.fromEntries(new URLSearchParams(queryString).entries()),
      });
      return;
    }
    const parsed = new URL(target);
    let path = parsed.pathname;
    if (path.startsWith('/pointage/')) {
      path = path.slice('/pointage'.length);
    }
    router.push({
      path: path || fallback,
      query: Object.fromEntries(parsed.searchParams.entries()),
    });
  } catch (error) {
    router.push(fallback);
  }
}

export async function initPushNotifications(router) {
  if (initialized) return;

  const { Capacitor } = await import('@capacitor/core');
  if (!isAndroidNative(Capacitor)) return;

  initialized = true;
  const { PushNotifications } = await import('@capacitor/push-notifications');

  await PushNotifications.createChannel({
    id: PUSH_CHANNEL_ID,
    name: 'Alertes pointage',
    description: 'Retards, absences et sorties automatiques',
    importance: 5,
    visibility: 1,
    sound: 'default',
    vibration: true,
  });

  await PushNotifications.addListener('registration', async (token) => {
    registeredToken = token?.value || '';
    try {
      await postPushToken('/api-pointage/push/register', registeredToken);
    } catch (error) {
      console.error('Erreur enregistrement push:', error);
    }
  });

  await PushNotifications.addListener('registrationError', (error) => {
    console.error('Erreur FCM:', error);
  });

  await PushNotifications.addListener('pushNotificationReceived', () => {
    window.dispatchEvent(new CustomEvent('pointage-notification-received'));
  });

  await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    const data = action?.notification?.data || {};
    pushRoute(router, data.route || '/notifications');
  });

  let permission = await PushNotifications.checkPermissions();
  if (permission.receive === 'prompt') {
    permission = await PushNotifications.requestPermissions();
  }
  if (permission.receive === 'granted') {
    await PushNotifications.register();
  }
}

export async function unregisterPushNotifications() {
  if (!registeredToken) return;
  try {
    await postPushToken('/api-pointage/push/unregister', registeredToken);
  } catch (error) {
    console.error('Erreur désactivation push:', error);
  } finally {
    registeredToken = '';
    initialized = false;
  }
}
